import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData, postData } from './comonsearch';
import * as dataAccess from 'app/utils/ajax';

export const getAllDataReportList = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/overall-data-list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};
export const getAllTotalPointsReportList = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/overall-points-list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};
export const getNewUserDataReportList = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/new-user-database-list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};
export const getAllVoucherClaimedReportList = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/voucher-claim-list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const getLiabilityReport = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/liability-report`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const getRedemtionReport = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/redemption-report`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const postRedemptionReport = async (param, payload) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/redemption-report`;
  let responseObj = await postData(baseUrl, param, payload);
  return responseObj;
};

export const getSlabBifurcationReport = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/slab-bifurcation`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

//-------------Data Analylitics Graph-------------------------------//

export const getslabvsmember = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/slab-vs-member`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const getslabvsearnpoints = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/slab-vs-earn-points`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const slabvsusedpoints = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/slab-vs-used-points`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const slabvstopbrand = async (param) => {
  const baseUrl = `${API_CONSTANTS.REPORT}/slab-vs-top-brand`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};
